import { render } from "./MineActive.vue?vue&type=template&id=4961886c&scoped=true"
import script from "./MineActive.vue?vue&type=script&lang=js"
export * from "./MineActive.vue?vue&type=script&lang=js"

import "./MineActive.vue?vue&type=style&index=0&id=4961886c&lang=less&scoped=true"

import exportComponent from "G:\\website\\work\\xmjh\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4961886c"]])

export default __exports__